import { render, staticRenderFns } from "./ResultBad.vue?vue&type=template&id=a7ff6cb0"
import script from "./ResultBad.vue?vue&type=script&lang=js"
export * from "./ResultBad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports